import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Ticket } from "lucide-react";
import RedeemCodeDialog from "@/components/RedeemCodeDialog";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [redeemOpen, setRedeemOpen] = useState(false);

  const onLogout = async () => { await logout(); nav("/"); };
  const isAdmin = user && user.role === "admin";

  return (
    <>
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FBF9F4]/80 border-b border-black/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-home" className="flex items-baseline gap-2">
            <span style={{ fontFamily: "'Cormorant Garamond', serif" }} className="text-2xl tracking-tight font-semibold">Soirée</span>
            <span className="hidden sm:inline text-[10px] tracking-[0.25em] uppercase text-neutral-500">Invitations · RSVPs</span>
          </Link>
          <nav className="flex items-center gap-1 sm:gap-2">
            {user && user.id ? (
              <>
                <button
                  data-testid="nav-redeem-code"
                  onClick={() => setRedeemOpen(true)}
                  className="flex items-center gap-2 px-3 py-1.5 border border-black/10 hover:border-neutral-900 rounded-sm text-xs"
                >
                  <Ticket size={14} />
                  <span className="tabular-nums font-medium">{user.credits || 0}</span>
                  <span className="text-neutral-500 hidden sm:inline">credit{(user.credits || 0) === 1 ? "" : "s"}</span>
                  <span className="text-neutral-400 hidden md:inline">·</span>
                  <span className="text-neutral-700 hidden md:inline">Redeem</span>
                </button>
                {isAdmin && (
                  <Link to="/admin"><Button variant="ghost" data-testid="nav-admin" className="rounded-sm">Admin</Button></Link>
                )}
                <Link to="/dashboard"><Button variant="ghost" data-testid="nav-dashboard" className="rounded-sm">Dashboard</Button></Link>
                <Link to="/create"><Button data-testid="nav-create" className="rounded-sm bg-neutral-900 hover:bg-neutral-800">Create</Button></Link>
                <Button variant="ghost" onClick={onLogout} data-testid="nav-logout" className="rounded-sm hidden sm:inline-flex">Log out</Button>
              </>
            ) : (
              <>
                <Link to="/login"><Button variant="ghost" data-testid="nav-login" className="rounded-sm">Log in</Button></Link>
                <Link to="/register"><Button data-testid="nav-register" className="rounded-sm bg-neutral-900 hover:bg-neutral-800">Get Started</Button></Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <RedeemCodeDialog open={redeemOpen} onOpenChange={setRedeemOpen} />
    </>
  );
}
